const CODE_PATTERN = /^[A-Z2-9]{4,12}$/;

export function normalizePairingCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function isValidPairingCode(code: string): boolean {
  return CODE_PATTERN.test(code);
}
